import React, { useState } from 'react'
import moment from 'moment'
import AnDateTimePicker from '../../../../../../components/DateTime/DateTimePicker'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { Alert } from '@mui/material'
import FluidType from './FluidType'
import Dose from './Dose'
import BatchExpiry from './BatchExpiry'

const IVFluids = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })

  return (
    <Box padding={1}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} lg={6}>
          <Typography variant="title2">IV Fluids</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <AnDateTimePicker
            date={moduleValues.dateTime}
            fullWidth
            onChange={(newDate) =>
              setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
            }
            size="small"
          />
        </Grid>
        <FluidType moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <Dose moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <BatchExpiry moduleValues={moduleValues} setModuleValues={setModuleValues} />

        <Grid item xs={12}>
          <Button
            onClick={() => submitModule('IV Fluids', moduleValues)}
            variant="contained"
            color="success"
            fullWidth
          >
            Submit
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

export default IVFluids
